import { render, staticRenderFns } from "./Begin.vue?vue&type=template&id=1ccaae26&scoped=true"
import script from "./Begin.vue?vue&type=script&lang=js"
export * from "./Begin.vue?vue&type=script&lang=js"
import style0 from "./Begin.vue?vue&type=style&index=0&id=1ccaae26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccaae26",
  null
  
)

export default component.exports